import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles } from 'lucide-react';

export default function Success() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard after 5 seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e8f5e9 0%, #e3f2fd 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #66bb6a 0%, #42a5f5 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          animation: 'bounce 0.6s ease-in-out'
        }}>
          <CheckCircle size={48} color="white" />
        </div>

        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#2e7d32',
          marginBottom: '16px'
        }}>
          Welcome to Teacher Plan!
        </h1>

        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          Your subscription is now active! You now have access to:
        </p>

        <div style={{
          background: '#e8f5e9',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <Sparkles size={20} color="#66bb6a" />
            <span style={{ fontSize: '16px', color: '#2e7d32', fontWeight: '600' }}>
              50 generations per month
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <Sparkles size={20} color="#66bb6a" />
            <span style={{ fontSize: '16px', color: '#2e7d32', fontWeight: '600' }}>
              All file types supported
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <Sparkles size={20} color="#66bb6a" />
            <span style={{ fontSize: '16px', color: '#2e7d32', fontWeight: '600' }}>
              Material history & favorites
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Sparkles size={20} color="#66bb6a" />
            <span style={{ fontSize: '16px', color: '#2e7d32', fontWeight: '600' }}>
              DOCX & PPTX downloads
            </span>
          </div>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          style={{
            width: '100%',
            padding: '16px',
            background: 'linear-gradient(135deg, #66bb6a 0%, #42a5f5 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'transform 0.2s',
            boxShadow: '0 4px 12px rgba(102, 187, 106, 0.3)'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Go to Dashboard
        </button>

        <p style={{ fontSize: '14px', color: '#999', marginTop: '16px' }}>
          Redirecting automatically in 5 seconds...
        </p>
      </div>
    </div>
  );
}